var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu-item" },
    [
      _c(
        "router-link",
        {
          staticClass: "menu-link",
          attrs: { to: _vm.path },
          nativeOn: {
            click: function ($event) {
              return _vm.handleClick.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "menu-caption" }, [
        _vm._v("\n    " + _vm._s(_vm.caption) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }